export const MODES = {
    PROD: 'PROD',
    DEV: 'DEV'
}

// !!! DO NOT RENAME THESE TYPES (to support already created forms);
export const INPUT_TYPES = {
    STARS_RATING: 'stars-radio',
    SELECT: 'select',
    SELECT_USER_GROUP: 'select-user-group',
    SELECT_RADIO: 'select(radio)',
    LONG_ADDRESS: 'long-address',
    SHORT_ADDRESS: 'short-address',
    TOGGLE: 'toggle',
    DATE: 'date',
    TIME: 'time',
    NUMBER: 'number',
    TERMS: 'terms-label',
    LABEL: 'label',
    SECTION_BREAK: 'section break',
    INPUT: 'input',
    EMAIL: 'email',
    HEADER: 'header',
    TEXTAREA: 'textarea',
    FILE_PICKER: 'file-picker',
    PASSWORD: 'password',
    REGISTRATION: 'registration',
    DESCRIPTION: 'description',
    HTML: 'html',
    SUBMIT_BUTTON: 'submit-button',
    BUTTON: 'button',
    IMAGE: 'image',
    ADD_TO_CALENDAR: 'add-to-calendar',
    JAVA_SCRIPT: 'java-script'
}

export const REGISTRATION_TYPES = {
    TITLE: 'title',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    ADDRESS_LINE_1: 'addressLine1',
    ADDRESS_LINE_2: 'addressLine2',
    TOWN: 'town',
    REGION: 'region',
    COUNTRY: 'country',
    POSTCODE: 'postcode',
    COMPANY: 'company',
    POSITION: 'position',
    WORK_TEL: 'WorkTelephone',
    HOME_TEL: 'HomeTelephone',
    MOBILE_TEL: 'mobileTelephone',
};

export const alignOptions = [
    { label: 'start', value: 'flex-start' },
    { label: 'center', value: 'center' },
    { label: 'end', value: 'flex-end' },
];

export const BUILDER_TYPES = {
    FORM: 'FORM',
    SUCCESS_PAGE: 'SUCCESS_PAGE'
}

export const colorPickers = [
    { label: 'Choose elements color', colorKey: 'elementColor', settingsKey: 'elementColor' },
    { label: 'Choose background color', colorKey: 'backgroundColor', settingsKey: 'backgroundColor' },
    { label: 'Choose text color', colorKey: 'textColor', settingsKey: 'textcolor' },
];
